

import { Users, Info, Zap } from 'lucide-react';

const About = () => {
  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <div className="flex justify-center mb-6">
            <Zap className="h-16 w-16 text-primary" />
          </div>
          <h1 className="text-4xl font-bold mb-4">About ChargeShare</h1>
          <p className="text-muted-foreground text-xl">
            Powering the future of electric vehicle charging, one shared station at a time.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-card p-6 rounded-lg shadow-sm">
            <Users className="h-12 w-12 text-primary mb-4" />
            <h2 className="text-2xl font-semibold mb-4">Our Mission</h2>
            <p className="text-muted-foreground">
              ChargeShare aims to create a collaborative network of electric vehicle charging stations, 
              making charging accessible, affordable, and convenient for everyone.
            </p>
          </div>

          <div className="bg-card p-6 rounded-lg shadow-sm">
            <Info className="h-12 w-12 text-primary mb-4" />
            <h2 className="text-2xl font-semibold mb-4">Who We Are</h2>
            <p className="text-muted-foreground">
              We're a team of EV enthusiasts and tech innovators dedicated to solving the challenges 
              of electric vehicle charging infrastructure through community-driven solutions.
            </p>
          </div>
        </div>

        <div className="mt-12 bg-card p-8 rounded-lg text-center">
          <h2 className="text-3xl font-bold mb-4">Our Vision</h2>
          <p className="text-muted-foreground text-xl max-w-2xl mx-auto">
            We envision a world where every electric vehicle owner can easily find, book, 
            and share charging stations, reducing range anxiety and promoting sustainable transportation.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
